import { FC } from 'react'
import { Row, Col, Text, Breadcrumb, Content, Image } from '@/client/components'
import * as S from './styles'
import { FeaturedProps } from '../types'

export const Featured: FC<FeaturedProps> = ({
  breadcrumb,
  title,
  subtitle,
  description,
  second_title,
  second_description,
  featured_img
}) => (
  <S.Featured>
    <Row>
      <Col>
        <Breadcrumb pages={breadcrumb} />
      </Col>
    </Row>
    <Row>
      <Col>
        <S.MainFeatured>
          <S.LeftFeatured>
            <Text as='h2' color='primary' family='heading'>
              {subtitle}
            </Text>
            <Text as='h1' size='xxlg' family='heading' weight='bold' margin='0 0 2.5rem' itemProp='name'>
              {title}
            </Text>
            <Content content={description} />

            {second_title && (
              <Text as='h3' size='lg' family='heading' weight='bold'>
                {second_title}
              </Text>
            )}
            {second_description && <Content content={second_description} />}
          </S.LeftFeatured>

          <S.Product>
            <S.ProductImg>
              <S.OutlinedSquare />
              <Image hasBreakpoint imageData={featured_img} priority />
            </S.ProductImg>
          </S.Product>
        </S.MainFeatured>
      </Col>
    </Row>
  </S.Featured>
)
